<template>
  <v-dialog :value="true" width="90vw"  scrollable persistent>
    <template>
      <v-card flat  height="90vh" :loading="loading"  >
        <template v-slot:progress>
          <v-progress-linear
            indeterminate
            color="primary lighten-1  "
          ></v-progress-linear>
        </template>
          <v-toolbar dense flat tile dark color="primary" class="mb-0 " height="36"  max-height="36">
            <v-toolbar-title class="body-2 text-uppercase">Vencimiento Remitos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
            <v-btn x-small icon @click="$store.commit('setViewPastDuePayments')">
              <v-icon>fa fa-close</v-icon>
            </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="px-0 py-1 " > 
            <v-data-table
              
              dense
              min-height="400px"
              class="caption elevation-0"     
              :headers="headers"
              :items="items"
              :fixed-header="true"
              
              :hide-default-footer="true"
              :items-per-page="-1"          
              :mobile-breakpoint=600
              no-data-text="Sin datos para mostrar!"
              
           >
              <template v-slot:item="{item,isMobile,headers} ">
                <DataGridBody :item="item" :headers="headers" :isMobile="isMobile" />
              </template>
            </v-data-table>
        </v-card-text>
      </v-card> 
    </template>
</v-dialog>

</template>

<script>
import {format, addDays} from "date-fns"
import {mapGetters} from 'vuex'

export default {
    name: 'RemitosVencidos',

    mixins: [],
    props:[],


    components: {
      DataGridBody: () => import ('@/components/DataGridBody_v2'),
    },


    data: () => ({
      //
      loading:false,
      items:[],
      headers:[],

    }),

    created: function () {
      console.log("ITEM-->",this.item)
      this.headers=[
        { text: 'REMITO',align: 'start' ,sortable: false,  value: 'remitoID', class:"text-truncate", type:"text", width:'80px' },
        { text: 'CLIENTE',align: 'start' ,sortable: false,  value: 'razonSocial', class:"text-truncate text-uppercase", type:"text"},
        { text: 'FECHA',align: 'start' ,sortable: false,  value: 'fecha', type:"date", width:'120px' },
        { text: 'DIAS',align: 'center',sortable: false, value: 'dias', type:"text"},
        { text: 'F VEN 1',align: 'start',sortable: false, value: 'fVencimiento1', type:"date", width:'120px'},
        { text: 'F VEN 2',align: 'start',sortable: false, value: 'fVencimiento2', type:"date", width:'120px'},
        { text: 'F VEN 3',align: 'start',sortable: false, value: 'fVencimiento3', type:"date",width:'120px'},
        
      ]
    },

    mounted: async function () {
      try {
        let opt={
              method: 'GET', 
              mode: 'cors'
        }
        let response = await fetch(`${this.ROOT_API}cms/remitos/vencimientos`, opt);

        if (response.ok){
          let data=await response.json()

          this.items=data.map(x=>{
            if (x.dias>=10) x.rowColor='yellow'
            if (x.dias>=25) x.rowColor='orange'
            if (x.dias>=40) x.rowColor='red'

            
            return x
          })




        }
      } catch (error) {
        alert(error)
      }
    },

    watch: {
    },

    methods: {
      calculaFormaPago(){
      },



      async save () {
        let url

        let opt={
          mode: 'cors',
          method:'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },  
          body: JSON.stringify({
              cliente:{clienteID:this.item.clienteID,razonSocial:this.item.razonSocial}, 
              estadoID:70, 
              pedidos:this.pedidos,
              detalle:this.Items,
              allItems:this.allItems,
              subtotal: this.subTotal,
              tipoRemito:this.tipo,
              fPago:this.fPago
            })
        }

        url = `${this.ROOT_API}cms/remitos/`    
        let response = await fetch(`${url}`, opt)
      },

      async initialize () {


      },
    },

    computed: {
      ...mapGetters(['SESSION','ROOT_API']),


      countItems: function () {
        // let productos = this.items.filter(i => i.action!='D')
        return //productos.length
      },

      subTotal: function () {
        /*
        let productos = this.items.filter(i => i.action!='D')
        let subtotal = productos.reduce((s,i) => s+=(i.precioCosto * i.cantidad),0) 
        */
        let subtotal = this.Items.reduce((s,i) => s+=(parseFloat(i.precioCosto) * i.cantidad),0)
        return subtotal.toFixed(2)
      },
     
    },
  }
</script>